module.exports = __webpack_public_path__ + "img/zgyh.7a8ce8a4.png";